import React from "react";
import { Link } from "react-router-dom";
import useCustomerOrders from "../../hooks/useCustomerOrders";
import Footer from "../../components/Footer";
import Header from "../../components/Header";

const OrdersPage = () => {
  const { orders, loading, error, refetchOrders } = useCustomerOrders();

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    try {
      const date = new Date(dateString);
      return (
        date.toLocaleDateString("tr-TR", {
          year: "numeric",
          month: "long",
          day: "numeric",
        }) +
        " " +
        date.toLocaleTimeString("tr-TR", { hour: "2-digit", minute: "2-digit" })
      );
    } catch (e) {
      return dateString;
    }
  };

  const getStatusText = (status) => {
    switch (status) {
      case "pending":
        return "Beklemede";
      case "processing":
        return "Hazırlanıyor";
      case "shipped":
        return "Yolda";
      case "completed":
        return "Teslim Edildi";
      case "cancelled":
        return "İptal Edildi";
      default:
        return status || "Bilinmiyor";
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <Header />
      <div className="flex-grow max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-12 w-full">
        <h1 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-8">
          Siparişlerim
        </h1>

        {loading && (
          <p className="text-center text-gray-500 py-10">
            Siparişler yükleniyor...
          </p>
        )}
        {error && (
          <div className="text-center text-red-500 py-10">
            <p>Hata: {error}</p>
            <button
              onClick={refetchOrders}
              className="mt-4 px-4 py-2 border border-red-300 text-red-600 rounded hover:bg-red-50"
            >
              Tekrar Dene
            </button>
          </div>
        )}

        {!loading && !error && orders.length === 0 && (
          <p className="text-center text-gray-500 py-10">
            Henüz siparişiniz bulunmamaktadır.
          </p>
        )}

        {!loading && !error && orders.length > 0 && (
          <div className="space-y-6">
            {orders.map((order) => (
              <div
                key={order.id}
                className="bg-white shadow overflow-hidden sm:rounded-lg"
              >
                <div className="px-4 py-5 sm:px-6 bg-gray-50 border-b border-gray-200 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-2">
                  <div>
                    <h3 className="text-lg leading-6 font-medium text-gray-900">
                      Sipariş #{order.id}
                    </h3>
                    <p className="mt-1 max-w-2xl text-sm text-gray-500">
                      {formatDate(order.created_at)}
                    </p>
                  </div>
                  <span
                    className={`inline-flex items-center px-3 py-0.5 rounded-full text-sm font-medium ${
                      order.status === "completed"
                        ? "bg-green-100 text-green-800"
                        : order.status === "cancelled"
                        ? "bg-red-100 text-red-800"
                        : "bg-yellow-100 text-yellow-800"
                    }`}
                  >
                    {getStatusText(order.status)}
                  </span>
                </div>
                <div className="border-t border-gray-200 px-4 py-5 sm:p-0">
                  <dl className="sm:divide-y sm:divide-gray-200">
                    {order.dealer_name && (
                      <div className="py-3 sm:py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                        <dt className="text-sm font-medium text-gray-500">
                          Bayi
                        </dt>
                        <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                          {order.dealer_name}
                        </dd>
                      </div>
                    )}
                    {order.total_amount && (
                      <div className="py-3 sm:py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                        <dt className="text-sm font-medium text-gray-500">
                          Toplam Tutar
                        </dt>
                        <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                          {order.total_amount} TL
                        </dd>
                      </div>
                    )}
                    {order.items && order.items.length > 0 && (
                      <div className="py-3 sm:py-4 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-6">
                        <dt className="text-sm font-medium text-gray-500">
                          Ürünler
                        </dt>
                        <dd className="mt-1 text-sm text-gray-900 sm:mt-0 sm:col-span-2">
                          {order.items
                            .map((item) => item.product_name)
                            .join(", ")}
                        </dd>
                      </div>
                    )}
                    <div className="py-3 sm:py-4 sm:px-6 text-right">
                      <Link
                        to={`/order/${order.id}`}
                        className="text-sm font-medium text-indigo-600 hover:text-indigo-500"
                      >
                        Detayları Gör
                      </Link>
                    </div>
                  </dl>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
};

export default OrdersPage;
